import separatedElements from 'core/components/common/separatedElements';
import { LinksConsumer } from 'core/components/linksContext';
import { showSnackbar } from 'core/components/snackbar';
import { DEFAULT_SOON_CAUSE } from 'core/const';
import injectSheet from 'core/style/injectSheet';
import { WithStyles } from 'core/style/interfaces';
import { getRichContent } from 'core/utils';
import { formatTimeSpanHHMM, formatToLocalDayMonth, formatToLocalTime, isImpossibleDate } from 'core/utils/date';
import React from 'react';
import { GetPrivateProductDetailDataQuery } from 'site/graphql';
import TeacherIcon from '../../../../svg/user.svg';
import { formItemCardStyles } from './formItemCardStyles';

type IPrivateProductWebinarCardProps = {
    webinar: GetPrivateProductDetailDataQuery['purchasedProduct']['productForms'][0]['webinars'][0];
};

class PrivateProductWebinarCard extends React.PureComponent<
    IPrivateProductWebinarCardProps & WithStyles<typeof formItemCardStyles>
> {
    checkSyncState = () => {
        const { myParticipation, syncState, date, soonCause } = this.props.webinar;
        const currentDate = formatToLocalTime(new Date());

        if (syncState === 'FINISHED') {
            if (myParticipation) {
                window.open(`${myParticipation.url}`, '_blank');
            } else {
                showSnackbar({
                    snackbarErrors: [
                        {
                            message: soonCause || DEFAULT_SOON_CAUSE,
                        },
                    ],
                });
            }
        } else {
            let message = 'Ошибка синхронизации. Обратитесь в тех. поддержку.';

            if (syncState === 'DID_NOT_START') {
                if (isImpossibleDate(date)) {
                    message = soonCause || DEFAULT_SOON_CAUSE;
                } else if (currentDate >= formatToLocalTime(date)) {
                    message = `Начало занятия ${formatToLocalDayMonth(date)} в ${formatToLocalTime(date)}`;
                } else if (currentDate < formatToLocalTime(date)) {
                    message = `Занятие еще не началось. Начало занятия ${formatToLocalDayMonth(
                        date,
                    )} в ${formatToLocalTime(date)}`;
                }
            }

            if (syncState === 'PENDING') {
                message =
                    'Синхронизация еще не завершена. ' +
                    'Попробуйте обновить страницу через несколько минут или ' +
                    'подключитесь к вебинару по ссылке из письма, которое мы вам отправили.';
            }

            showSnackbar({
                snackbarErrors: [
                    {
                        message,
                    },
                ],
            });
        }
    };

    render() {
        const { classes, webinar } = this.props;
        const { title, description, hours, lecturers, eventRecord, materials } = webinar;

        return (
            <div className={classes.root}>
                <div className={classes.content}>
                    <h3 className={classes.title}>{title}</h3>
                    <span className={classes.teachers}>
                        <TeacherIcon className={classes.icon} />
                        <LinksConsumer>
                            {links =>
                                separatedElements(lecturers, lect => (
                                    <links.teacherDetail.Link
                                        key={lect.id}
                                        to={links.teacherDetail.url(lect.id)}
                                        className={classes.teacher}
                                    >
                                        {lect.account.firstName} {lect.account.lastName}
                                    </links.teacherDetail.Link>
                                ))
                            }
                        </LinksConsumer>
                    </span>
                    {hours && <div className={classes.hours}>Продолжительность: {formatTimeSpanHHMM(hours)}</div>}
                    <div
                        className={classes.shortDesc}
                        dangerouslySetInnerHTML={{ __html: getRichContent(description) }}
                    />
                    <a className={classes.button} onClick={() => this.checkSyncState()}>
                        Смотреть
                    </a>
                    <div className={classes.addons}>
                        {materials && materials[0] && materials[0].link && (
                            <a
                                className={classes.addons__button}
                                onClick={() => window.open(`${materials[0].link}`, '_blank')}
                            >
                                Материал
                            </a>
                        )}
                        {eventRecord && eventRecord.link && (
                            <a
                                className={classes.addons__button}
                                onClick={() => window.open(`${eventRecord.link}`, '_blank')}
                            >
                                Видеозапись
                            </a>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default injectSheet(formItemCardStyles, 'PrivateProductWebinarCard')(PrivateProductWebinarCard);
